<template>
  <div class="container">
    <h1>Welcome</h1>
    <p>
      The first prop you’ll come across is app. This simply tells the toolbar to stick to the top when the user starts scrolling down.
      If you remove the app prop, the toolbar will scroll away with the rest of the page. Try it yourself and see what happens.
      We can further add more props to customize the appearance of our toolbar.
    </p>
    <v-container class="lighten-5">
      <v-data-iterator
        :items="items"
        :items-per-page.sync="itemsPerPage"
        :page="page"
        :search="search"
        :sort-by="sortBy.toLowerCase()"
        :sort-desc="sortDesc"
        hide-default-footer
      >
        <template v-slot:header>
          <v-toolbar dark color="#f0a07c" class="mb-1">
            <v-text-field
              v-model="search"
              clearable
              flat
              solo-inverted
              hide-details
              prepend-inner-icon="search"
              label="Search"
            ></v-text-field>
            <template v-if="$vuetify.breakpoint.mdAndUp">
              <v-spacer></v-spacer>
              <v-select
                v-model="sortBy"
                flat
                solo-inverted
                hide-details
                :items="keys"
                prepend-inner-icon="search"
                label="Sort by"
              ></v-select>
            </template>
          </v-toolbar>
        </template>

        <template v-slot:default="props">
          <v-row>
            <v-col v-for="item in props.items" :key="item.name" cols="12" sm="6" md="3">
              <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 16 : 2" class="mx-auto" max-width="auto">
                  <v-img src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg" height="200px"></v-img>

                  <v-card-title>{{item.title}}</v-card-title>

                  <v-card-subtitle class="pb-0">{{item.location}}</v-card-subtitle>
                  <v-card-text class="text--primary">
                    <div class="block text-truncate" style="max-width: 600px;">{{item.description}}</div>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text>Share</v-btn>

                    <v-btn color="purple" text>Explore</v-btn>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </template>

        <template v-slot:footer>
          <v-row class="mt-2" align="center" justify="center">
            <span class="grey--text">Items per page</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn dark text color="primary" class="ml-2" v-on="on">
                  {{ itemsPerPage }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(number, index) in itemsPerPageArray"
                  :key="index"
                  @click="updateItemsPerPage(number)"
                >
                  <v-list-item-title>{{ number }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-spacer></v-spacer>

            <span class="mr-4 grey--text">Page {{ page }} of {{ numberOfPages }}</span>
            <v-btn fab dark color="#141a46" class="mr-1" @click="formerPage">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn fab dark color="#141a46" class="ml-1" @click="nextPage">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      itemsPerPageArray: [4, 8, 12],
      search: "",
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 4,
      sortBy: "location",
      keys: ["location", "title"],
      items: [
        {
          location: "Abidjan",
          title: "Assamblée annuelle",
          description:
            "The first prop you’ll come across is app. This simply tells the toolbar to stick to the top when the user starts scrolling down"
        },
        {
          location: "Brazzavile",
          title: "Assemblée régionale",
          description: "The first prop you’ll come across is app."
        },
        {
          location: "Cotonou",
          title: "Assemblée nationale",
          description: "The first prop you’ll come across is app."
        },
        {
          location: "Dakar",
          title: "Assemblée nationale",
          description: "The first prop you’ll come across is app."
        },
        {
          location: "Abidjan",
          title: "Assamblée annuelle",
          description:
            "The first prop you’ll come across is app. This simply tells the toolbar to stick to the top when the user starts scrolling down"
        },
        {
          location: "Brazzavile",
          title: "Assemblée régionale",
          description: "The first prop you’ll come across is app."
        },
        {
          location: "Cotonou",
          title: "Assemblée nationale",
          description: "The first prop you’ll come across is app."
        },
        {
          location: "Dakar",
          title: "Assemblée nationale",
          description: "The first prop you’ll come across is app."
        }
      ]
    };
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter(key => key !== `Name`);
    }
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    }
  }
};
</script>